import { isCmccEnvironment, cmccGoBack } from './bridge'

/**
 * 物理返回键接管
 * - 弹窗打开时通过 pushState 占位，返回时消费掉弹窗
 * - 首页按返回 → 在 APP 内调 cmccGoBack 让原生退到上一层，否则不处理
 */

var handlers = []   // 弹窗关闭回调栈：{ close: fn }
var installed = false

function onPopState() {
  if (handlers.length > 0) {
    var top = handlers.pop()
    try { top.close && top.close() } catch (e) {}
    return
  }
  // 无弹窗：判断是否首页，是则调原生返回
  var hash = window.location.hash || ''
  if (hash === '' || hash === '#/' || hash === '#/home') {
    if (isCmccEnvironment()) {
      cmccGoBack().catch(function() {})
      // 阻止再次退出，push 回来
      history.pushState({ gcRoot: true }, '')
    }
  }
}

export function installBackHandler() {
  if (installed) return
  installed = true
  // 保证栈里至少有一条记录用于承接首次返回
  try { history.pushState({ gcRoot: true }, '') } catch (e) {}
  window.addEventListener('popstate', onPopState)
}

/**
 * 弹窗打开时调用：push 一个占位历史，返回键会先关闭弹窗
 * @param {Function} closeFn 关闭弹窗的函数
 * @returns {Function} 手动调用来主动移除注册（比如用户点了叉关闭）
 */
export function pushOverlay(closeFn) {
  handlers.push({ close: closeFn })
  try { history.pushState({ gcOverlay: true }, '') } catch (e) {}
  return function unregister() {
    // 用户主动关闭时移除自己，并回退历史
    var idx = handlers.lastIndexOf(this)
    if (idx >= 0) handlers.splice(idx, 1)
    try { history.back() } catch (e) {}
  }
}
